export const getRatioBarsChartLegendItems = series => {
  return [
    ...series.bars.map(bar => ({ type: 'square', label: bar.label, color: bar.color })),
    { type: 'line', label: series.line.label, color: series.line.color },
  ]
}
